module.exports = __webpack_public_path__ + "static/img/stone_wx.4c3a24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/child/stone_wx.png
// module id = WmRI
// module chunks = 26